/* DI LORENZO | Editorial reveal. Native scroll, zero touch interception. */
(function(){
  'use strict';
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector='.dlx-products__head,.dlb-focus4__content,.dlm-library__header,.dlb-focus4__photos,.dlx-products__grid';
  const observed=new WeakSet();
  let observer=null;
  function init(scope){
    if(reduce.matches||!('IntersectionObserver' in window))return;
    const root=scope||document;
    const nodes=Array.from(root.querySelectorAll(selector)).filter(n=>!observed.has(n));
    if(!nodes.length)return;
    if(!observer)observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(!entry.isIntersecting)return;
        entry.target.classList.add('dlb-motion-visible');
        observer.unobserve(entry.target);
      });
    },{threshold:0.06,rootMargin:'0px 0px 60px 0px'});
    document.body.classList.add('dlb-motion-ready');
    nodes.forEach(node=>{
      observed.add(node);
      if(node.getBoundingClientRect().top<window.innerHeight*.94)return;
      node.classList.add('dlb-motion-target');
      observer.observe(node);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
